<template>
  <div>
    <v-row>
      <v-col>
        <h3>Form D Filters</h3>
      </v-col>
      <v-col class="text-right">
        <v-btn variant="text">Clear all</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import api from '@/store/api'
import { mapStoreState, mapStoreGetters } from '@/store/helpers'
import { mapFields } from '@/store/helpers'

// Mixins
import FormattersMixin from '@/mixins/formatters'
import cloneDeep from 'lodash/cloneDeep'

export default {
  mixins: [FormattersMixin],

  data() {
    return {
      form_4_filters: [
        {
          identifier: 'stock_ticker',
          title: 'Stock Ticker',
          type: 'text'
        },
        {
          identifier: 'txt_filer_name',
          title: 'Executive names or stock names',
          type: 'keyword',
          selectedOption: 'all',
          options: [
            { text: 'Search All Fields', value: 'all' },
            { text: 'Search Stock Ticker', value: 'issuer_trading_symbol' },
            { text: 'Search Stock Name', value: 'stock_name' },
            { text: 'Search Owner Names', value: 'owner_name' }
          ]
        },
        {
          identifier: 'transaction_date',
          title: 'Transaction Date',
          type: 'date_range',
          items: [
            { id: 1, description: 'Past Month' },
            { id: 2, description: 'Past Year' }
          ]
        },
        {
          identifier: 'is_derivative',
          title: 'Is Derivative',
          items: [
            { id: 1, description: 'Yes' },
            { id: 2, description: 'No' }
          ]
        },
        {
          identifier: 'acquired_disposed_code',
          title: 'Acquire or Dispose',
          items: [
            { id: 'a', description: 'Acquire' },
            { id: 'd', description: 'Dispose' }
          ]
        },
        {
          identifier: 'owner_type',
          title: 'Owner',
          items: [
            { id: 'is_officer', description: 'Officer' },
            { id: 'is_director', description: 'Director' },
            { id: 'is_ten_percent_owner', description: '10% Owner' },
            { id: 'is_c_level_officer', description: 'C-Level Officer' },
            { id: 'is_other', description: 'Other' }
          ]
        },
        {
          identifier: 'is_10b5',
          title: 'Rule 10b5-1',
          items: [
            { id: 'only', description: 'Include Rule 10b5-1' },
            { id: 'exclude', description: 'Exclude Rule 10b5-1' }
          ]
        },
        {
          identifier: 'transaction_code',
          title: 'Transaction Codes',
          items: [
            ...useWwStore().ownershipTCodes.map(code => ({
              id: code.id,
              description: code.description
            }))
          ]
        }
      ]
    }
  },

  computed: {
    ...mapFields({
      criteria: 'app.trendFinderCriteria'
    })
  },

  watch: {},

  mounted() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
.filer-name-cell-min-width {
  min-width: 300px;
}
</style>
